// Generated by CoffeeScript 1.12.6
module.exports.goodEggsLocationIdsToFoodhubSlug = {
  'maritime': 'MAR1',
  'habit': 'OKN2',
  'rankin': 'sfbay',
  'vernon': 'VRN1'
};
